export {AssetTaskViewRequirementsContainer as AssetTaskViewRequirements} from './AssetTaskViewRequirementsContainer';
export {ProjectTaskViewRequirementsContainer as ProjectTaskViewRequirements} from './ProjectTaskViewRequirementsContainer';
export {TemplateTaskViewRequirementsContainer as TemplateTaskViewRequirements} from './TemplateTaskViewRequirementsContainer';



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewRequirements/index.js